import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';
import { INIT, LOADING, SUCCESS, ERROR } from '../../utils/constants';

import {
  updateCardAPI,
  updateInvoiceAPI,
  refillBalanceAPI,
  deleteCardAPI,
  deleteInvoiceAPI,
  getUserBalanceHistoryAPI,
} from './api';

export const UPDATE_CARD = 'advaice/payment/UPDATE_CARD';
export const UPDATE_CARD_SUCCESS = 'advaice/payment/UPDATE_CARD_SUCCESS';
export const UPDATE_CARD_ERROR = 'advaice/payment/UPDATE_CARD_ERROR';

export const UPDATE_INVOICE = 'advaice/payment/UPDATE_INVOICE';
export const UPDATE_INVOICE_SUCCESS = 'advaice/payment/UPDATE_INVOICE_SUCCESS';
export const UPDATE_INVOICE_ERROR = 'advaice/payment/UPDATE_CARD_ERROR';

export const REFILL_BALANCE = 'advaice/payment/REFILL_BALANCE';
export const REFILL_BALANCE_SUCCESS = 'advaice/payment/REFILL_BALANCE_SUCCESS';
export const REFILL_BALANCE_ERROR = 'advaice/payment/REFFILL_BALANCE_ERROR';

export const DELETE_CARD = 'advaice/payment/DELETE_CARD';
export const DELETE_CARD_SUCCESS = 'advaice/payment/DELETE_CARD_SUCCESS';
export const DELETE_CARD_ERROR = 'advaice/payment/DELETE_CARD_ERROR';

export const DELETE_INVOICE = 'advaice/payment/DELETE_INVOICE';
export const DELETE_INVOICE_SUCCESS = 'advaice/payment/DELETE_INVOICE_SUCCESS';
export const DELETE_INVOICE_ERROR = 'advaice/payment/DELETE_INVOICE_ERROR';

export const GET_BALANCE_HISTORY = 'advaice/payment/GET_BALANCE_HISTORY';
export const GET_BALANCE_HISTORY_SUCCESS = 'advaice/payment/GET_BALANCE_HISTORY_SUCCESS';
export const GET_BALANCE_HISTORY_ERROR = 'advaice/payment/GET_BALANCE_HISTORY_ERROR';

export const RESET_BALANCE_HISTORY = 'advaice/payment/RESET_BALANCE_HISTORY';


export const ANNUL_STORE_ERRORS = 'advaice/payment/ANNUL_STORE_ERRORS';

const initialState = {
  updateCardStatus: INIT,
  updateCardError: '',
  updateInvoiceStatus: INIT,
  updateInvoiceError: '',
  refillBalanceStatus: INIT,
  refilllBalanceError: '',
  deleteCardStatus: INIT,
  deleteCardError: '',
  deleteInvoiceStatus: INIT,
  deleteInvoiceError: '',
  balanceHistoryStatus: INIT,
  balanceHistoryError: '',
  balanceHistory: [],
  balanceHistoryPage: 0,
  hasMoreBalanceHistory: false,

};
export const paymentStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_CARD: {
      return {
        ...state,
        updateCardStatus: LOADING,
      };
    }
    case UPDATE_CARD_SUCCESS: {
      return {
        ...state,
        updateCardStatus: SUCCESS,
      };
    }
    case UPDATE_CARD_ERROR: {
      return {
        ...state,
        updateCardStatus: ERROR,
        updateCardError: action.payload,
      };
    }
    case UPDATE_INVOICE: {
      return {
        ...state,
        updateInvoiceStatus: LOADING,
      };
    }
    case UPDATE_INVOICE_SUCCESS: {
      return {
        ...state,
        updateInvoiceStatus: SUCCESS,
      };
    }
    case UPDATE_INVOICE_ERROR: {
      return {
        ...state,
        updateInvoiceStatus: ERROR,
        updateInvoiceError: action.payload,
      };
    }
    case REFILL_BALANCE: {
      return {
        ...state,
        refillBalanceStatus: LOADING,
      };
    }
    case REFILL_BALANCE_SUCCESS: {
      return {
        ...state,
        refillBalanceStatus: SUCCESS,
      };
    }
    case REFILL_BALANCE_ERROR: {
      return {
        ...state,
        refillBalanceStatus: ERROR,
        refillBalanceError: action.payload,
      };
    }

    case DELETE_CARD: {
      return {
        ...state,
        deleteCardStatus: LOADING,
      };
    }
    case DELETE_CARD_SUCCESS: {
      return {
        ...state,
        deleteCardStatus: SUCCESS,
      };
    }
    case DELETE_CARD_ERROR: {
      return {
        ...state,
        deleteCardStatus: ERROR,
        deleteCardError: action.payload,
      };
    }

    case DELETE_INVOICE: {
      return {
        ...state,
        deleteInvoiceStatus: LOADING,
      };
    }
    case DELETE_INVOICE_SUCCESS: {
      return {
        ...state,
        deleteInvoiceStatus: SUCCESS,
      };
    }
    case DELETE_INVOICE_ERROR: {
      return {
        ...state,
        deleteInvoiceStatus: ERROR,
        deleteInvoiceError: action.payload,
      };
    }
    case RESET_BALANCE_HISTORY: {
      return {
        ...state,
        balanceHistory: [],
        hasMoreBalanceHistory: true,
        balanceHistoryPage: 0,
      };
    }
    case GET_BALANCE_HISTORY: {
      return {
        ...state,
        deleteInvoiceStatus: LOADING,
      };
    }
    case GET_BALANCE_HISTORY_SUCCESS: {
      const previousArray = action.payload.data.first ?
        [] : state.balanceHistory;
      return {
        ...state,
        balanceHistory: [...previousArray, ...action.payload.data.content],
        hasMoreBalanceHistory: !action.payload.data.last,
        balanceHistoryPage: action.payload.data.number,
      };
    }
    case GET_BALANCE_HISTORY_ERROR: {
      return {
        ...state,
        deleteInvoiceStatus: ERROR,
        deleteInvoiceError: action.payload,
      };
    }


    case ANNUL_STORE_ERRORS: {
      return {
        ...state,
        updateInvoiceStatus: INIT,
        updateInvoiceError: '',
        updateCardStatus: INIT,
        updateCardError: '',
        refillBalanceStatus: INIT,
        refillBalanceError: '',
      };
    }

    default: {
      return state;
    }
  }
};

export const updateCard = data => ({
  type: UPDATE_CARD,
  payload: data,
});

export const updateInvoice = data => ({
  type: UPDATE_INVOICE,
  payload: data,
});

export const refillBalance = data => ({
  type: REFILL_BALANCE,
  payload: data,
});

export const annulStoreErrors = () => ({
  type: ANNUL_STORE_ERRORS,
});

export const deleteCard = () => ({
  type: DELETE_CARD,
});

export const deleteInvoice = () => ({
  type: DELETE_INVOICE,
});

export const getBalanceHistory = data => ({
  type: GET_BALANCE_HISTORY,
  payload: data,
});

export const resetBalanceHistory = () => ({
  type: RESET_BALANCE_HISTORY,
});

export const updateCardObservable = (store, requestData) =>
  Observable.fromPromise(updateCardAPI(requestData))
    .map(data => ({ type: UPDATE_CARD_SUCCESS, payload: data }))
    .catch(err => Observable.of({ type: UPDATE_CARD_ERROR, payload: err }));

export const deleteCardObservable = () =>
  Observable.fromPromise(deleteCardAPI())
    .map(data => ({ type: DELETE_CARD_SUCCESS, payload: data }))
    .catch(err => Observable.of({ type: DELETE_CARD_ERROR, payload: err }));

export const updateInvoiceObservable = (store, requestData) =>
  Observable.fromPromise(updateInvoiceAPI(requestData))
    .map(data => ({ type: UPDATE_INVOICE_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: UPDATE_INVOICE_ERROR, payload: err }));

export const deleteInvoiceObservable = () =>
  Observable.fromPromise(deleteInvoiceAPI())
    .map(data => ({ type: DELETE_INVOICE_SUCCESS, payload: data }))
    .catch(err => Observable.of({ type: DELETE_INVOICE_ERROR, payload: err }));

export const refillBalanceObservable = (store, requestData) =>
  Observable.fromPromise(refillBalanceAPI(requestData))
    .map(data => ({ type: REFILL_BALANCE_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: REFILL_BALANCE_ERROR, payload: err }));

export const getBalanceHistoryObservable = (store, requestData) =>
  Observable.fromPromise(getUserBalanceHistoryAPI(requestData))
    .map(data => ({ type: GET_BALANCE_HISTORY_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: GET_BALANCE_HISTORY_ERROR, payload: err }));

export const updateCardEpic = (action$, store) =>
  action$
    .ofType(UPDATE_CARD)
    .flatMap(action => updateCardObservable(store, action.payload));

export const deleteCardEpic = (action$, store) =>
  action$
    .ofType(DELETE_CARD)
    .flatMap(action => deleteCardObservable(store, action.payload));

export const updateInvoiceEpic = (action$, store) =>
  action$
    .ofType(UPDATE_INVOICE)
    .flatMap(action => updateInvoiceObservable(store, action.payload));
export const deleteInvoiceEpic = (action$, store) =>
  action$
    .ofType(DELETE_INVOICE)
    .flatMap(action => deleteInvoiceObservable(store, action.payload));

export const refillBalanceEpic = (action$, store) =>
  action$
    .ofType(REFILL_BALANCE)
    .flatMap(action => refillBalanceObservable(store, action.payload));

export const getBalanceHistroyEpic = (action$, store) =>
  action$
    .ofType(GET_BALANCE_HISTORY)
    .flatMap(action => getBalanceHistoryObservable(store, action.payload));

export const paymentEpic = combineEpics(
  updateCardEpic,
  updateInvoiceEpic,
  refillBalanceEpic,
  deleteCardEpic,
  deleteInvoiceEpic,
  getBalanceHistroyEpic,
);



// WEBPACK FOOTER //
// ./src/reducers/payment/duck.js